import { Component, input } from "@angular/core";
import { FloorplanAlarmDevice } from "@domain/project/floorplan/floorplan-alarm-device";
import { FloorplanCustomPartNumbersComponent } from "@project/floorplanner/floorplan-custom-part-numbers/floorplan-custom-part-numbers.component";

@Component({
  selector: "app-floorplan-alarm-device-detail-form",
  imports: [FloorplanCustomPartNumbersComponent],
  templateUrl: "./floorplan-alarm-device-detail-form.component.html",
  standalone: true,
})
export class FloorplanAlarmDeviceDetailFormComponent {
  readonly alarmDevice = input.required<FloorplanAlarmDevice>();
}
